var _style, _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadmapCurrent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84.6 98.7",
    style: {
      enableBackground: "new 0 0 84.6 98.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B7C0EB;}\n\t.st1{fill:#E4E7FB;}\n\t.st2{fill:#EFF1FE;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:url(#SVGID_1_);}\n\t.st5{fill:url(#SVGID_2_);}\n\t.st6{fill:url(#SVGID_3_);}\n\t.st7{fill:url(#SVGID_4_);}\n\t.st8{fill:none;stroke:#7E8FAA;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st9{fill:#7E8FAA;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.6,34.8c-2-1.1-2-3,0-4.1l37.1,0.2c1.9-1.1,5.1-1.1,7.1,0l37.4-0.2c2,1.1,2,3,0,4.1L46,56.4 c-1.9,1.1-5.1,1.1-7.1,0L1.6,34.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.6,26.3c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.2 c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0c0,0.1-0.1,0.1-0.2,0.2c0,0,0,0,0,0c-0.1,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0.1-0.2,0.1 c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1L46,49.8L46,54.6L83.1,33c0,0,0,0,0.1,0c0,0,0.1-0.1,0.1-0.1 c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0,0c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0,0 c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0,0c0-0.1,0-0.1,0.1-0.2c0,0,0-0.1,0-0.1 c0,0,0,0,0,0c0,0,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.2c0,0,0-0.1,0-0.1v0l0.1-4.8 C84.6,26.2,84.6,26.2,84.6,26.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.6,28.2c-1-0.6-1.5-1.3-1.5-2.1L0,30.9c0,0.8,0.5,1.5,1.5,2.1l37.4,21.6l0.1-4.8L1.6,28.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.1,24.1c2,1.1,2,3,0,4.1L46,49.8c-1.9,1.1-5.1,1.1-7.1,0L1.6,28.2c-2-1.1-2-3,0-4.1L38.7,2.5 c1.9-1.1,5.1-1.1,7.1,0L83.1,24.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1361.1062,
    y1: 8760.9707,
    x2: -1361.1062,
    y2: 8781.3467,
    gradientTransform: "matrix(-2.4035 0 0 -2.4035 -3229.0676 21105.9668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1F4FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    style: {
      stopColor: "#F7F9FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1.6,26.5c-2-1.1-2-3,0-4.1L38.7,0.9c1.9-1.1,5.1-1.1,7.1,0l37.4,21.6c2,1.1,2,3,0,4.1L46,48.1 c-1.9,1.1-5.1,1.1-7.1,0L1.6,26.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.3732,
    y1: 24.4874,
    x2: 79.3295,
    y2: 24.4874
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FEFC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42BEAD"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M6.7,26.3c-1.7-1-1.7-2.6,0-3.6L39.1,3.8c1.7-1,4.5-1,6.2,0L78,22.7c1.7,1,1.7,2.6,0,3.6L45.6,45.2 c-1.7,1-4.5,1-6.2,0L6.7,26.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.939,
    y1: 24.4873,
    x2: 16.7661,
    y2: 24.4873
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1F4FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    style: {
      stopColor: "#F7F9FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M42.4,39.3L16.8,24.5L42.2,9.7c0,0,0.1,0,0.1,0l25.7,14.8L42.4,39.3C42.5,39.3,42.5,39.3,42.4,39.3 C42.5,39.3,42.4,39.3,42.4,39.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -322.091,
    y1: 4263.167,
    x2: -319.5741,
    y2: 4263.167,
    gradientTransform: "matrix(3.1971 0 0 3.1971 1068.1143 -13577.335)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFF1FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E7FB"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M45.5,54.8c0.2-0.1,0.8-0.4,0.9-0.5v-4.8c-0.1,0.1-0.7,0.4-0.8,0.4c0,0-0.1,0-0.1,0.1 c-0.1,0.1-0.3,0.1-0.4,0.1c0,0-0.1,0-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.2,0-0.3,0.1 c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0.1-0.6,0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.4-0.1-0.5-0.2c-0.1,0-0.2-0.1-0.2-0.1 c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.8-0.5-0.9-0.5v4.9c0.1,0.1,0.7,0.4,0.9,0.5c0,0,0.1,0,0.1,0.1c0.1,0,0.1,0.1,0.2,0.1c0,0,0,0,0,0 c0.2,0.1,0.4,0.1,0.5,0.2c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0 c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0 c0.2,0,0.4,0,0.6-0.1c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3-0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0,0.1,0 c0,0,0.1,0,0.1,0c0.1,0,0.3-0.1,0.4-0.2C45.4,54.9,45.4,54.8,45.5,54.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M42.3,25.4v72.4V25.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M41.4,25.4c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9 C41.8,26.4,41.4,25.9,41.4,25.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M41.4,97.7c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9 C41.8,96.8,41.4,97.2,41.4,97.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapCurrent);
export default __webpack_public_path__ + "static/media/roadmap-current.07fd4ab1e01720669266bf8dd783dfbb.svg";
export { ForwardRef as ReactComponent };